import React from "react";
import {
  DatePicker,
  FieldDropSide,
  ManageCensusLayout,
  MultiSelectDropdown,
  CsplTable as Table,
  Link,
  AddToolTip,
} from "../../../../components";

const columns = [
  {
    label: "Source Mapping",
    className: "column-field",
    columnName: "sourceMapping",
  },
  {
    label: "Contributions",
    className: "column-dateTimeModified",
    columnName: "contributions",
  },
  {
    label: "Earning",
    className: "column-previousValue",
    columnName: "earning",
  },
  {
    label: "Total",
    className: "column-updatedValue",
    columnName: "total",
  },
];
const data = [
  {
    sourceMapping: "Pre Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "After Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "Roth",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
];
const TransactionHistoryTile = ({
  mapperProfileName = "Pre Tax",
  description = 12000,
  sourceType = 1200,
  profileType = "Input Map",

  profileId,
}) => {
  return (
    <div
      className="border rounded mr-3 p-3 mb-3 text-decoration-tile"
      style={{
        display: "flex",
        width: "100%",
        alignItems: "start",
        gap: "10px",
        flexWrap: "nowrap",
        color: "black",
        justifyContent: "space-between",
      }}
    >
      <div className="d-flex">
        <div>
          {mapperProfileName.length > 30 ? (
            <AddToolTip name={mapperProfileName}>
              <div className="main-font">
                {(mapperProfileName || "").slice(0, 30)}...
              </div>
            </AddToolTip>
          ) : (
            <div className="main-font">{mapperProfileName}</div>
          )}
          {description?.length > 30 ? (
            <AddToolTip name={description}>
              <div className="below-font">
                {(description || "").slice(0, 30)}...
              </div>
            </AddToolTip>
          ) : (
            <div className="below-font">{description}</div>
          )}
        </div>
      </div>
      <div>
        <div className="main-font">After Tax</div>
        <div className="below-font">$1204</div>
      </div>

      <div>
        <div className="main-font">Roth</div>

        <div className="below-font">{sourceType}</div>
      </div>
    </div>
  );
};
export const SourceAllocationMapping = (props) => {
  return (
    <div className="source-allocation-mapping">
      <div className="source-allocation-header">Source allocation mapping</div>
      <TransactionHistoryTile />
      <TransactionHistoryTile />
      <TransactionHistoryTile />
      <TransactionHistoryTile />
      <TransactionHistoryTile />
      <TransactionHistoryTile />
    </div>
  );
};
